import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CaretUp, CaretDown } from '@phosphor-icons/react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './style';

const PriceBreakupAccordion = (props) => {
  const {
    title,
    content,
    initialState,
    className,
    width,
    price,
    isLoading = true,
    ...attr
  } = props;

  const [isOpen, setIsOpen] = useState(initialState);

  const onClick = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div
      className={`custom-accordion-wrapper w-full flex flex-col gap-1 ${isOpen ? 'open' : 'closed'} ${className}`}
      {...(width && ({ style: { width } }))}
      {...attr}
    >
      <div className="accordion-title-wrapper text-black text-14 flex items-center justify-between gap-3">
        <div
          className="custom-accordion-title flex w-full min-w-0 items-center justify-between gap-2 text-grey-70 text-14 flex-1"
          onClick={onClick}
        >
          {isLoading ? (
            <Skeleton className="flex-1" containerClassName="w-[70%]" />
          ) : (
            <>
              <span className="min-w-0 flex-1">{title}</span>
              {isOpen ? (
                <CaretUp size={20} color="#101010" />
              ) : (
                <CaretDown size={20} color="#101010" />
              )}
            </>)}
        </div>
        {isLoading ? (<Skeleton className="flex-1" containerClassName="w-[100px]" />) : (<div className="label-14 text-black">₹ {parseFloat(price || 0).toFixed(2)}</div>)}
      </div>
      {isOpen && (
        <div className="accordion-content text-justify text-16 text-grey-70 pt-3">
          {content}
        </div>
      )}
    </div>
  );

};

PriceBreakupAccordion.propTypes = {
  title: PropTypes.node,
  content: PropTypes.node,
  initialState: PropTypes.bool,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

PriceBreakupAccordion.defaultProps = {
  title: null,
  content: null,
  initialState: false,
  className: '',
  width: undefined,
};

export default PriceBreakupAccordion;
